import type { AmmoProductFillResult } from '../../app/api/agent'

function hasText (value: string | null | undefined): boolean {
  return typeof value === 'string' && value.trim().length > 0
}

/** True when the API returned enough structure to apply suggestions. */
export function isAmmoProductFillResultValid (result: unknown): result is AmmoProductFillResult {
  if (!result || typeof result !== 'object') return false

  const r = result as AmmoProductFillResult
  if (!r.spec || typeof r.spec !== 'object') return false
  if (!r.product || typeof r.product !== 'object') return false

  const hasSpecSignal = hasText(r.spec.name) || hasText(r.spec.caliber)
  const hasProductSignal =
    hasText(r.product.brand) ||
    hasText(r.product.name) ||
    (r.product.grainWeight != null && r.product.grainWeight > 0)

  return hasSpecSignal || hasProductSignal
}
